import type { BadgeProps } from "@/components/ui/badge";
import type { ProposalState } from "@/domains/application/constant/status";

export const PROPOSAL_STATE_VARIANTS: Record<
  ProposalState,
  BadgeProps["variant"]
> = {
  scouted: "outline",
  view: "light-primary",
  accepted: "success",
  rejected: "destructive",
  expired: "disabled",
};
